export const translations = {
  nav: {
    home: { fr: 'Accueil', en: 'Home' },
    about: { fr: 'Qui Sommes-Nous', en: 'About Us' },
    projects: { fr: 'Projets', en: 'Projects' },
    sales: { fr: 'Ventes', en: 'Sales' },
    contact: { fr: 'Contact', en: 'Contact' }
  },
  hero: {
    title: { 
      fr: 'Construire votre avenir, durable et intelligente', 
      en: 'Building your sustainable and smart future' 
    },
    description: { 
      fr: 'Pionnière en Suisse depuis plus de 12 ans, my iHome SA a intégré les objectifs sociétaux et environnementaux dans son ADN et sa raison d\'être.',
      en: 'Pioneer in Switzerland for over 12 years, my iHome SA has integrated societal and environmental objectives into its DNA and purpose.'
    },
    cta: { fr: 'Découvrir nos projets', en: 'Discover our projects' },
    contactBtn: { fr: 'Nous contacter', en: 'Contact us' }
  },
  about: {
    title: { fr: 'Qui Sommes-Nous', en: 'About Us' },
    subtitle: { fr: 'Excellence et Innovation', en: 'Excellence and Innovation' },
    description: {
      fr: 'my iHome est une entreprise totale et générale qui concrétise vos projets de construction, de surélévation, transformation ou de rénovation énergétique de la conception à la livraison clé en main.',
      en: 'my iHome is a comprehensive construction company that brings your building, extension, transformation or energy renovation projects to life from design to turnkey delivery.'
    },
    mission: {
      fr: 'Elle développe et construit des bâtiments durables et intelligents selon un mode de construction optimisé afin de diminuer la production de déchets et réduire les émissions CO2.',
      en: 'We develop and build sustainable and intelligent buildings using an optimized construction method to reduce waste production and CO2 emissions.'
    },
    satisfaction: {
      title: { fr: '100% de satisfaction', en: '100% satisfaction' },
      point1: { 
        fr: '100% de nos clients promoteurs nous ont commandé un nouvel ouvrage et nous sont fidèles',
        en: '100% of our developer clients have ordered new projects from us and remain loyal'
      },
      point2: {
        fr: '100% de nos partenaires nous ont recommandé à leurs contacts',
        en: '100% of our partners have recommended us to their contacts'
      }
    }
  },
  projects: {
    title: { fr: 'Nos Projets', en: 'Our Projects' },
    subtitle: { fr: 'Excellence architecturale', en: 'Architectural excellence' },
    categories: {
      all: { fr: 'Tous', en: 'All' },
      maisons: { fr: 'Maisons', en: 'Houses' },
      appartements: { fr: 'Appartements', en: 'Apartments' },
      hotel: { fr: 'Hôtel', en: 'Hotel' },
      industriel: { fr: 'Industriel/Artisanal', en: 'Industrial/Craft' }
    },
    viewMore: { fr: 'Voir plus', en: 'View more' },
    noProjects: { fr: 'Aucun projet disponible', en: 'No projects available' }
  },
  features: {
    durable: { fr: 'Durable', en: 'Sustainable' },
    intelligente: { fr: 'Intelligente', en: 'Smart' },
    passive: { fr: 'Passive', en: 'Passive' },
    surMesure: { fr: 'Sur mesure', en: 'Custom made' },
    hauteQualite: { fr: 'Haute qualité', en: 'High quality' },
    economique: { fr: 'Économique', en: 'Economical' },
    prixGaranti: { fr: 'Prix garanti', en: 'Guaranteed price' },
    delaisGaranti: { fr: 'Délais garanti', en: 'Guaranteed timeline' },
    bois: { fr: 'Bois', en: 'Wood' },
    beton: { fr: 'Béton', en: 'Concrete' }
  },
  sales: {
    title: { fr: 'Offres', en: 'Sales' },
    subtitle: { fr: 'Opportunités disponibles', en: 'Available opportunities' },
    description: {
      fr: 'Découvrez nos offres actuelles de biens immobiliers.',
      en: 'Discover our current real estate offers.'
    }
  },
  contact: {
    title: { fr: 'Contactez-nous', en: 'Contact us' },
    subtitle: { fr: 'Parlons de votre projet', en: "Let's talk about your project" },
    name: { fr: 'Nom', en: 'Name' },
    email: { fr: 'Email', en: 'Email' },
    phone: { fr: 'Téléphone', en: 'Phone' },
    subject: { fr: 'Sujet', en: 'Subject' },
    message: { fr: 'Message', en: 'Message' },
    send: { fr: 'Envoyer', en: 'Send' },
    success: { fr: 'Message envoyé avec succès!', en: 'Message sent successfully!' },
    error: { fr: 'Erreur lors de l\'envoi', en: 'Error sending message' }
  },
  footer: {
    rights: { 
      fr: 'Tous droits réservés', 
      en: 'All rights reserved' 
    },
    description: {
      fr: 'Construction durable et intelligente en Suisse',
      en: 'Sustainable and smart construction in Switzerland'
    }
  }
};